import React, { useEffect } from 'react'
import CommonBanner from "../components/Common Banner Component/HeroBanner"
import TestimonialForm from '../components/TestimonialForm/TestimonialForm'
import Blog from "../components/CardBlog/CardBlog"
import ServicesTextContent from '../components/ServicesTextContent/ServicesTextContent'
import GridCard from '../components/GridCard/GridCard'
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs'
import LetsGetStarted from '../components/LetsGetStarted/LetsGetStarted'
import FaqSection from '../components/FaqSection/FaqSection'
import { useLocation } from 'react-router-dom'
import PartnerCompanies from '../components/PartnerCompanies/PartnerCompanies'
import { Helmet } from 'react-helmet'

const AccountingServicesData = [
    {
        icon:"/images/icons/at-as-card-1.svg",
        title:"Bookkeeping & Financial Reporting",
        listPoint:[
            "Full-cycle bookkeeping (monthly, quarterly, yearly",
            "Financial statement preparation",
            "Accounts payable & receivable management",
            "Bank reconciliations",
            "Cash flow monitoring & forecasting",
            "Year-end closing & adjustments",
        ]
    },
    {
        icon:"/images/icons/at-as-card-2.svg",
        title:"Payroll & Compliance",
        listPoint:[
            "Payroll processing and reporting",
            "Direct deposits & pay stubs",
            "T4, T5, and ROE filings",
            "WSIB, CPP, EI & statutory remittances",
            "Employee benefit deductions and remittances",
        ]
    },
    {
        icon:"/images/icons/at-as-card-3.svg",
        title:"Government Filings & Compliance",
        listPoint:[
            "GST/HST filings and remittances",
            "WSIB & EHT compliance",
            "Record-keeping & document organization",
            "Audit support and CRA compliance",
        ]
    },
    {
        icon:"/images/icons/at-as-card-4.svg",
        title:"Compilation Engagement Report",
        listPoint:[
          "GAAP-compliant financial statements",
          "Ideal for small businesses needing reports for banks or compliance",
          "Prepared by a trusted CPA",
          "Delivered on time, every time",
        ]
    },
]

const TaxServicesData = [
    {
        icon:"/images/icons/at-ts-card-1.svg",
        title:"Corporate Tax Services",
        listPoint:[
            "Corporate tax return preparation (T2)",
            "Tax deductions and credits maximization",
            "Year-end tax filing & corporate tax planning",
            "CRA audit representation",
        ]
    },
    {
        icon:"/images/icons/at-ts-card-2.svg",
        title:"Personal Tax Services",
        listPoint:[
            "Personal tax return preparation (T1)",
            "Self-employed & freelance tax services",
            "Rental property tax reporting",
            "Retirement & investment tax strategies",
        ]
    },
    {
        icon:"/images/icons/at-ts-card-3.svg",
        title:"Tax Planning & Strategy",
        listPoint:[
            "Small business tax optimization",
            "Business structure tax efficiency (Incorporation vs. Sole Proprietor)",
            "Tax deferral strategies",
            "Estate & succession tax planning",
        ]
    },

    // ==================
    {
        icon:"/images/icons/at-ts-card-1.svg",
        title:"Corporate Tax Services",
        listPoint:[
            "Corporate tax return preparation (T2)",
            "Tax deductions and credits maximization",
            "Year-end tax filing & corporate tax planning",
            "CRA audit representation",
        ]
    },
    {
        icon:"/images/icons/at-ts-card-2.svg",
        title:"Personal Tax Services",
        listPoint:[
            "Personal tax return preparation (T1)",
            "Self-employed & freelance tax services",
            "Rental property tax reporting",
            "Retirement & investment tax strategies",
        ]
    },
    {
        icon:"/images/icons/at-ts-card-3.svg",
        title:"Tax Planning & Strategy",
        listPoint:[
            "Small business tax optimization",
            "Business structure tax efficiency (Incorporation vs. Sole Proprietor)",
            "Tax deferral strategies",
            "Estate & succession tax planning",
        ]
    }
]

const WhyChooseData = [
    {
        icon:"/images/icons/at-wc-card-1.svg",
        title:`<h4 class='color-white' style={{fontWeight:"700"}}>Experienced <br> Professionals</h4> `,
        content:"Decades of accounting & tax expertise."
    },
    {
        icon:"/images/icons/at-wc-card-2.svg",
        title:`<h4 class='color-white' style={{fontWeight:"700"}}>Compliance & <br> Accuracy</h4> `,
        content:"We ensure timely and accurate filings."
    },
    {
        icon:"/images/icons/at-wc-card-3.svg",
        title:`<h4 class='color-white' style={{fontWeight:"700"}}>Tax <br> Optimization</h4> `,
        content:"Minimize liabilities and maximize savings."
    },
    {
        icon:"/images/icons/at-wc-card-4.svg",
        title:`<h4 class='color-white' style={{fontWeight:"700"}}>Personalized <br> Solutions</h4> `,
        content:"Custom strategies tailored to your needs."
    },

]

const faqData = [
  {
    "title": "What documents do I need for my corporate tax return?",
    "content": "You need financial statements, business expenses, payroll records, and any CRA correspondence. Our team will guide you through the process."
  },
  {
    "title": "How do I know if my business needs to register for HST/GST?",
    "content": "Your business must register for HST/GST once your sales exceed $30,000 within a 12-month period. We’ll guide you through registration and compliance."
  },
  {
    "title": "How often should I file HST/GST?",
    "content": "It depends on your business revenue. We can help determine if you need to file monthly, quarterly, or annually."
  },
  {
    "title": "Can you help with CRA audits?",
    "content": "Yes! We provide audit support and representation to ensure compliance and help navigate CRA inquiries."
  },
  {
    "title": "What’s the deadline for filing corporate tax returns in Canada?",
    "content": "Corporate tax returns (T2) are due six months after the end of your fiscal year. However, any balance owing must be paid within three months. We’ll make sure nothing is missed."
  },
  {
    "title": "How can I reduce my corporate taxes legally?",
    "content": "Our team identifies deductions, credits, and smart tax strategies tailored to your business, ensuring you legally minimize your tax bill."
  },
  {
    "title": "What happens if I file taxes late or incorrectly?",
    "content": "Late or inaccurate filings can lead to costly penalties and audits. At Lotus Accounting, we ensure accurate and timely submissions to prevent these issues."
  },
  {
    "title": "Do you offer tax planning or just tax filing?",
    "content": "We do both. Our tax planning services help reduce your tax liability and improve your cash flow before filing deadlines."
  },
  {
    "title": "Are bookkeeping and payroll services available?",
    "content": "Yes, we provide full-cycle bookkeeping and payroll support tailored to your business needs—monthly, quarterly, or annual."
  },
  {
    "title": "Can I claim home office or vehicle expenses for my business?",
    "content": "Yes, if used for business purposes. We’ll help you track eligible deductions and keep compliant records."
  },
  {
    "title": "What is a Compilation Engagement (Notice to Reader)?",
    "content": "It’s a set of financial statements prepared from information you provide, without audit or review. It's commonly used for banks, lenders, or compliance."
  },
  {
    "title": "Do I need a Compilation Engagement or a Review Engagement?",
    "content": "Most small and medium-sized businesses only need a Compilation Engagement. If a third party (like a lender) requires more assurance, a Review or Audit may be needed. We’ll help you decide."
  },
  {
    "title": "How quickly can Lotus Accounting provide a Compilation Report?",
    "content": "We deliver your Compilation Reports promptly, always meeting your deadlines."
  },
  {
    "title": "Is a Compilation Report acceptable for loan applications?",
    "content": "Yes, many banks accept Notice to Reader statements. We ensure they are GAAP-compliant and professionally prepared."
  },
  {
    "title": "Will you help me understand the financial statements?",
    "content": "Absolutely. We don’t just send reports—we walk you through them, so you fully understand your business performance."
  }
]

function AccountingTaxes() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);
  return (
    <>
     <Helmet>
          <link rel="canonical" href="https://www.lotusaccounting.ca/accounting-taxes" />
           <title>
          CPA Accounting & Tax Services in Toronto | Lotus Accounting 
        </title>
        <meta
          name='description'
          content='CPA accounting, bookkeeping, payroll, and corporate & personal tax services in Toronto. Lotus Accounting helps businesses stay compliant, reduce taxes, and grow.'>
        </meta>
        </Helmet>
        <CommonBanner
         subHeading=""
         Heading="Accounting & Tax Services - Lotus Accounting"
         Paragraph=""
         btnText=""
         bgImg="/images/creative/services-bg.jpg"
         btn={false}
          showPartners={true}
        />
        <PartnerCompanies/>

        <ServicesTextContent
            heading={"Expert Accounting & Tax Solutions for Your Business"}
            content={"At Lotus Accounting, we provide comprehensive accounting and tax services to help businesses and individuals manage their finances with confidence. Our team of professionals ensures compliance, accuracy, and strategic financial planning to optimize your tax position and keep your business financially healthy."}
            img={'/images/creative/at-text-1.jpg'}
            shiftRow={true}
            bgColor={"#ffffff"}
            btnRef="/contact"
            btnCalendly={true}
        />

        <div id='accountingbookkeeping'>
          <GridCard
              heading="Accounting & Bookkeeping Services"
              gridCardData={AccountingServicesData}
              btnText="Learn More About Our Accounting Services"
              btnRef=""
              sliderCard={true}
          />
        </div>

        <div id='personalcorpratetax'>
          <GridCard
              heading="Tax Services"
              gridCardData={TaxServicesData}
              btnText="Learn More About Our Tax Services"
              btnRef=""
              sliderCard={true}
          />
        </div>
        
        <WhyChooseUs
            cardData={WhyChooseData}
        />

        {/* <ServicesTextContent
            heading={"Financial Statement Analysis"}
            content={"Explore the fundamental layers of your business's financial well-being through Lotus Accounting's Financial Statement Analysis service. Our seasoned professionals conduct a meticulous examination, unveiling key insights from your statements. Identifying strengths and pinpointing areas for improvement, we equip you with a clear understanding, empowering you to make informed decisions for the sustained success of your enterprise."}
            img={'/images/creative/services-1.png'}
            shiftRow={false}
            bgColor={"#ffffff"}
        />
        <ServicesTextContent
            heading={"Budgeting & Forecasting"}
            content={"Propel your business towards success with precision through Lotus Accounting's Budgeting & Forecasting consultation services. We empower you to craft realistic budgets and forecasts, granting you control over your financial future. By setting achievable goals and proactively managing resources, our guidance ensures strategic financial planning that aligns with your business objectives, fostering sustained growth and stability."}
            img={'/images/creative/services-2.png'}
            shiftRow={true}
            bgColor={"#F8F8F8"}
        />
        <ServicesTextContent
            heading={"Business Plan & Cash Flow Projections"}
            content={"Create a strategic roadmap with Lotus Accounting's Business Plan & Cash Flow Projections service. Our experts collaborate with you to craft comprehensive business plans and accurate cash flow projections. Whether you're launching a new venture or expanding an existing one, we facilitate the articulation of your goals, ensuring a financially sound and prosperous future for your business."}
            img={'/images/creative/services-3.png'}
            shiftRow={false}
            bgColor={"#ffffff"}
        />
        <ServicesTextContent
            heading={"Business Incorporation & Registration"}
            content={"Navigate the complex stages of business incorporation with assurance, benefiting from the expert guidance provided by Lotus Accounting. Our experts provide comprehensive assistance, addressing both legal and financial aspects of establishing your business entity. From selecting the optimal structure to fulfilling registration requirements, we ensure a seamless process. Trust us to lay the foundation for your business success through meticulous incorporation and registration services."}
            img={'/images/creative/services-4.png'}
            shiftRow={true}
            bgColor={"#F8F8F8"}
        /> */}

        <FaqSection
            heading='FAQ - Accounting & Tax Services'
            faqData={faqData}
        />
       
        {/* <Blog/> */}
        <TestimonialForm/>
        <LetsGetStarted/>
    </>
  )
}

export default AccountingTaxes